import { DEFAULT_LOCALE } from '@common/lang/lang';
import { CalculationParams } from '@features/settings/reducer';
import { Text } from '@react-pdf/renderer';
import { IntlProvider } from 'react-intl';

import { Attribute, DateRange, HydratedEntity } from '../../../types';
import { hydrateColumns } from '../../../utils/columns';
import { getColumns } from '../columns';
import FontProvider from '../FontProvider';
import Content from './Content';

export type DetailPDFProps = {
    data: HydratedEntity;
    attributes: Attribute[];
    languageData: Record<string, string>;
    dateRange: DateRange;
    locale: string;
    settings: {
        totalRatingWithCC: boolean;
        isDriver: boolean;
        shouldShowOvertakeInCruise?: boolean;
        calculationParameters: CalculationParams;
        isPerform3Enabled: boolean;
        shouldShowFuelType: boolean;
        shouldUseV3Ratings?: boolean;
        updatedAt: Date;
    };
};

const dieselColumns = [
    'operatingFuelConsumption',
    'fuelConsumption',
    'distanceFuelConsumption',
    'drivingConsumption',
    'idlingConsumption',
    'fuelEfficiency',
    'co2Emission',
    'operatingTime',
    'drivingTime',
    'idlingTime',
    'mileage',
    'averageWeight',
    'averageSpeed',
    'operatingDays',
];

const electricColumns = [
    'electricAverageOperatingConsumption',
    'electricOperatingConsumption',
    'electricAverageOperatingConsumptionRange',
    'electricAverageDrivingConsumption',
    'electricAverageIdlingConsumption',
    'electricRecuperation',
    'electricEfficiency',
    'electricCruiseControlRating',
    'electricOverspeedRating',
    'electricForesightedDrivingPercentage',
    'co2Emission',
    'operatingTime',
    'drivingTime',
    'idlingTime',
    'mileage',
    'averageWeight',
    'averageSpeed',
    'operatingDays',
];

function Pdf({ data, attributes, languageData, locale, dateRange, settings }: DetailPDFProps) {
    const columns = {
        electricColumns: hydrateColumns(getColumns(electricColumns), attributes),
        dieselColumns: hydrateColumns(getColumns(dieselColumns), attributes),
    };

    return (
        <FontProvider locale={locale}>
            <IntlProvider
                key={locale}
                locale={locale}
                messages={languageData}
                defaultLocale={DEFAULT_LOCALE}
                textComponent={Text}
            >
                <Content
                    columns={columns}
                    dateRange={dateRange}
                    data={data}
                    settings={settings}
                    attributes={attributes}
                />
            </IntlProvider>
        </FontProvider>
    );
}

export default Pdf;
